<script lang="ts">
	import BtnPrimary from '$lib/buttons/v2/btnPrimary.svelte';
	import { trackEvent } from '$lib/segment/client';
	import SbRichtext from '../components/sbRichtext.svelte';
	import Gift from '$lib/icons/gift.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			text: ISbRichtext;
			cta_title: string;
			asset: ISbStoryData[];
		}>['content'];
	}
	let { content }: Props = $props();
</script>

<section
	use:editable={content}
	class="relative mt-16 flex aspect-3/2 w-full flex-col justify-between overflow-hidden rounded-2xl bg-stone-2 bg-cover p-4 text-stone-5 lg:mt-28 lg:p-6"
>
	{#if content.asset?.length > 0}
		<div class="absolute inset-0">
			<Blok content={content.asset[0]} />
		</div>
		<div class="overlay pointer-events-none absolute inset-0"></div>
	{/if}

	{#if content.text}
		<div class="friendbuy-offer relative flex flex-1 flex-col font-serif text-[40px]/[110%]">
			<SbRichtext text={content.text} />
		</div>
	{/if}

	<BtnPrimary
		hasIcon
		size="small"
		theme="stone"
		class="self-start"
		onclick={() => trackEvent('friendbuy')}
		href="/refer"
		contentClass="flex items-center"
	>
		<Gift class="h-6 w-6" />
		<span class="p-[6px]">{content.cta_title}</span>
	</BtnPrimary>
</section>

<style lang="scss">
	div.overlay {
		background-color: rgba(0, 0, 0, 0.3);
	}

	div.friendbuy-offer {
		text-shadow: 0px 0px 14px rgba(255, 255, 255, 0.25);
	}
</style>
